import React, { Component } from "react";
import "./ProjectCardStyle.css";
import {useNavigate} from "react-router-dom";
import ARROW from "../media/back-arrow.png";
import Skill from "./Skill";

class ProjectCard extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            ghostChips : ["","",""],
            useGhost: this.props.useGhost
        }
        console.log("sss" + props.lastFilterIndex);
    }

    handleClick = () => {
        this.props.navigate("/project", {state:{projectID: this.props.projectID, skills: this.props.skills, lastFilterIndex: this.props.lastFilterIndex}});
    }
    
    render(){

        var category = "";
        if (this.props.category == "game"){
            category = "🎮";
        }else if (this.props.category == "software"){
            category = "🖥️";
        }else if (this.props.category == "art"){
            category = "🎨";
        }

       const pDate = this.props.time?.toDate ? this.props.time.toDate() : null;

    // 2. Calculate the threshold (2 months ago) in milliseconds
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

    // 3. Compare them using .getTime() to be 100% sure
    const isNew = pDate && pDate.getTime() > twoMonthsAgo.getTime();

        return !this.state.useGhost ? 
        
        <div onClick={this.handleClick} className="project-card fade-in">
            {isNew ? <h1 className="new-project">New</h1> : <div></div>}
            <div className="card-info">
                <img src={this.props.img}/>
                <h1>{this.props.name} {category}</h1>
                <div className="skills-used">
                    {/* <h1>{this.props.name}</h1> */}
                    {this.props.skills.map((skill,i)=><Skill i={skill} skill={skill}/>)}
                </div>
                <p className="desc-text">{this.props.desc}</p>
            </div>
            <p className="see-more"><img src={ARROW} /></p>
        </div>
        
        :
        
        <div className="project-card fade-in loopFade">
            <div className="card-info">
                <div className="project-img"/>
                <div className="skills-used">
                    {/* <h1>{this.props.name}</h1> */}
                    {this.state.ghostChips.map((skill,i)=><Skill i={skill} skill={skill} useGhost={true}/>)}
                </div>
                {this.state.ghostChips.map((skill,i)=>
                <p key={skill + i + "project_ghost"} style={{width:((this.state.ghostChips.length-i)/this.state.ghostChips.length*100)+"%",height:20,backgroundColor:"#6b6b6b"}}></p>
                )}
            </div>
            
        </div>;
    }
}


export default function(props) {
    const navigate = useNavigate();
    return <ProjectCard {...props} navigate={navigate} fadeDelay={props.fadeDelay} useGhost={props.useGhost ?? false} lastFilterIndex={props.lastFilterIndex}/>;
}
